/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { InspectableAssetImpl };
class InspectableAssetImpl {
    title;
    description;
    type;
    data;
    visual;
    constructor(path, asset) {
        this.title = asset.metadata?.title || path;
        this.description = asset.metadata?.description || "";
        this.type = asset.metadata?.type || "content";
        this.data = asset.data;
        this.visual = asset?.metadata?.visual || {};
    }
}
//# sourceMappingURL=inspectable-asset.js.map